export default "__VITE_PUBLIC_ASSET__0e669b2d__"